import { conversationServiceV2 } from 'config/api';

/**
 * @param {Object} param
 * */
const saveIntentShareToDB = async ({
  cmdId,
  messageType,
  associatePin,
  lookId,
  editId,
  editsStatus,
  productIds,
  skuIds,
  pimSkuIds,
  date,
  associateInfo,
  customerInfo,
}) => {
  try {
    await conversationServiceV2.post(
      '/intentShare',
      {
        associatePin,
        cmdId: cmdId.includes('temp_') ? '' : cmdId,
        messageType,
        skuIds,
        productIds,
        lookId,
        editId,
        editsStatus,
        pimSkuIds,
        date,
        associateInfo,
        customerInfo,
      },
      {
        httpClientOptions: { handleErrors: false },
      },
    );
  } catch (error) {
    return error;
  }
};

export default saveIntentShareToDB;
